import React, { Component } from 'react';
import { Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { translate } from 'react-i18next';

@translate(['common'])
export default class DeleteButton extends Component {

	static defaultProps = {
		size: 'sm',
		isPromise: false,
		text: false,
		ctext: 'Confirmer',
		disabled: false,
		disableMsg: false
	};

	constructor(props) {
		super(props);
		this.displayConfirm = this.displayConfirm.bind(this);
		this.cancelConfirm = this.cancelConfirm.bind(this);
		this.confirmDelete = this.confirmDelete.bind(this);

		this.state = {
			confirm: false,
			loading: false,
			circle: false
		}
	}

	displayConfirm() {
		this.setState({ confirm: true });
	}

	cancelConfirm() {
		this.setState({ confirm: false });
	}

	confirmDelete() {
		this.setState({ loading: true }, () => {

			if (this.props.isPromise == true) {
				this.props.callback().then(() => {
					this.setState({ confirm: false, loading: false });
				});

			} else {
				this.props.callback();
				this.setState({ confirm: false, loading: false });
			}


		});


	}

	render() {

		const {t} = this.props

		var text = this.props.text ? this.props.text : <i className="fa fa-remove" />;
		var ctext = this.props.ctext;

		let refreshClassName = 'fa fa-refresh';
		if (this.state.loading) {
			refreshClassName += ' fa-spin';
		}

		var size = "btn-" + this.props.size;
		var btnStyle = {}

		if (this.props.disabled == true) {
			btnStyle['pointerEvents'] = 'none'
		}

		if (this.props.circle == true) {

			if (this.props.size == 'xs') {
				btnStyle = {
					'width': '14px',
					'height': '14px',
					'text-align': 'center',
					'padding': '0px',
					'font-size': '10px',
					'border-radius': '4px',
					'line-height': '0px',
					'padding-top': '0px'
				}

			} else if (this.props.size == 'sm') {
				btnStyle = {
					width: '35px',
					height: '35px',
					textAlign: 'center',
					padding: '0px',
					fontSize: '20px',
					//lineHeight: '1.65',
					borderRadius: '8px',
				}

			} else if (this.props.size == 'lg') {

				btnStyle = {
					width: '79px',
					height: '79px',
					textAlign: 'center',
					padding: '0px',
					fontSize: '30px',
					borderRadius: '8px',
				}

			}
		}

		var content = [];
		if (this.state.confirm == true && !this.props.disabled) {
			content.push(
				<div>

					<div style={{ "position": "absolute", "zIndex": "10000", 'padding': '4px', 'top': '-5px', 'right': '0px', 'width': '100px' }} className="alert alert-warning" role="alert">
						
						<div style={{minWidth:"95px"}}>
							{ctext}

						</div>
						

						<br />
						<button type="button" className={"btn btn-danger " + size} onClick={this.confirmDelete}>
							{t("main.yes")}
						</button>
						&nbsp;
						<button type="button" className={"btn btn-primary " + size} onClick={this.cancelConfirm}>
							{t("main.no")}
						</button>
						&nbsp;<i style={{ 'display': this.state.loading ? 'inline' : 'none' }} className={refreshClassName} />
					</div>
				</div>

			);
		} else {

			const tooltip = this.props.disableMsg ? (
				<Tooltip id="tooltip"><strong>{this.props.disableMsg}</strong></Tooltip>
			) : <span />;




			content.push(
				<OverlayTrigger placement="right" overlay={tooltip}>
					<div style={{ display: 'inline-block', cursor: 'not-allowed' }}>

						<button disabled={this.props.disabled} type="button" style={btnStyle} className={"btn btn-danger " + size} onClick={this.displayConfirm}>
							{text}
						</button>

					</div>
				</OverlayTrigger>

			);
		}


		return (
			<div style={{ display: 'inline-block', position: 'relative'/*, width: '50px'*/, ...this.props.style }}>
				{content}
			</div>
		);
	}
}
